import React, { useState } from "react";
import { ChevronLeft, X } from "lucide-react";

export default function WhatsTaskPopup({ members, onClose, onPickOption }) {
  const [step, setStep] = useState(0);
  // steps: 0=Title, 1=Description, 2=Assignee, 3=Duration, 4=Checker
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [assignee, setAssignee] = useState(null);
  const [duration, setDuration] = useState(null);
  const [checker, setChecker] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredMembers = members.filter(m => (m.name || m.nick || '').toLowerCase().includes(searchQuery.toLowerCase()));

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (step === 0 && title.trim()) setStep(1);
      else if (step === 1) setStep(2);
      // For assignee/checker, enter should pick the first if available or require selection
    }
  };

  const handleCreate = (finalChecker) => {
    onPickOption({
      title,
      description,
      assignee,
      duration,
      checker: finalChecker
    });
  };

  const placeholders = [
    "Nombre de la tarea",
    "Descripción breve",
    "¿Quién se encarga?",
    "¿Cuánto tiempo tomará?",
    "¿Quién revisa?"
  ];

  return (
    <div style={{
      margin: "0 var(--space-4) var(--space-3)",
      backgroundColor: "#1c1c1e", // adapting to dark theme of composer
      border: "1px solid rgba(255,255,255,0.1)",
      borderRadius: "var(--radius-lg)",
      boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
      display: "flex",
      flexDirection: "column",
      position: "relative"
    }}>
      <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", borderBottom: "1px solid rgba(255,255,255,0.05)" }}>
        {step > 0 && (
          <button
            onClick={() => setStep(prev => Math.max(0, prev - 1))}
            style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#ccc', marginRight: '8px', padding: 0 }}
          >
            <ChevronLeft size={16} />
          </button>
        )}
        <span style={{ fontSize: "13px", fontWeight: "600", color: "#fff", flex: 1 }}>Crear Tarea</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', display: 'flex', color: '#888', padding: 0 }}><X size={14} /></button>
      </div>

      <div style={{ position: "relative", padding: "12px" }}>
        {(step === 2 || step === 4) && (
          <div style={{ display: "flex", overflowX: "auto", gap: "8px", marginBottom: "8px" }}>
            {filteredMembers.slice(0, 4).map((m, i) => (
              <div
                key={m.id}
                onClick={() => {
                  if (step === 2) {
                    setAssignee(m);
                    setStep(3);
                    setSearchQuery("");
                  } else {
                    handleCreate(m);
                  }
                }}
                style={{
                  display: "flex", flexDirection: "column", alignItems: "center", gap: "4px", cursor: "pointer",
                  padding: "4px", borderRadius: "8px", border: "1px solid rgba(255,255,255,0.1)", minWidth: "50px"
                }}
              >
                {m.image ? (
                  <img src={m.image} alt={m.nick} style={{ width: "24px", height: "24px", borderRadius: "50%", objectFit: "cover" }} />
                ) : (
                  <div style={{ width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#333", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "12px" }}>
                    {(m.name || m.nick || '?').charAt(0).toUpperCase()}
                  </div>
                )}
                <span style={{ fontSize: "10px", color: "#ccc", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "50px" }}>{m.nick || m.name}</span>
              </div>
            ))}
          </div>
        )}

        {step === 3 && (
          <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginBottom: "8px" }}>
            {[
              { label: '5 min', val: 5 },
              { label: '20 min', val: 20 },
              { label: '40 min', val: 40 },
              { label: '3 horas', val: 180 },
              { label: '7 horas', val: 420 }
            ].map(tag => (
              <div
                key={tag.val}
                onClick={() => {
                  setDuration(tag.val);
                  setStep(4);
                  setSearchQuery("");
                }}
                style={{ padding: '4px 10px', backgroundColor: 'rgba(255,255,255,0.1)', color: '#fff', borderRadius: '12px', fontSize: '11px', cursor: 'pointer', border: '1px solid rgba(255,255,255,0.05)' }}
              >
                {tag.label}
              </div>
            ))}
          </div>
        )}

        <input
          autoFocus
          type="text"
          value={step === 0 ? title : step === 1 ? description : searchQuery}
          onChange={(e) => {
            if (step === 0) setTitle(e.target.value);
            else if (step === 1) setDescription(e.target.value);
            else setSearchQuery(e.target.value);
          }}
          onKeyDown={handleKeyDown}
          placeholder={placeholders[step]}
          style={{
            width: "100%", padding: "8px 12px", borderRadius: "6px", border: "1px solid rgba(255,255,255,0.1)",
            backgroundColor: "#2c2c2e", color: "#fff", fontSize: "13px", outline: "none"
          }}
        />
      </div>

      <div style={{ height: '2px', backgroundColor: '#10b981', transition: 'width 0.3s ease', width: `${((step + 1) / 5) * 100}%`, borderRadius: '0 0 8px 8px' }} />
    </div>
  );
}
